import React, { useEffect, useState, memo } from "react";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import './workflowModals.css';

function IntelligenceConfirmationModal(props) {
    const addFlow = () => {
        props.skiporsave(true, "intelligence", props.props)
        props.toggleicon(true)
    }

    const skipFlow = () => {
        props.skiporsave(false, "intelligence", props.props)
        props.toggleicon(false)
    }
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            // backdrop="static"
            centered
            className={"smallmodal"}
        >
            <Modal.Header>
            <h6>Are you sure you want to add the flow?</h6>
            </Modal.Header>
            <Modal.Body>
                <p>The flow <b>{props.props.workflow.FlowName}</b> already exists. Do you want to create a duplicate?</p>
            </Modal.Body>
            <Modal.Footer className="workflow-footer">
                <div className="intent-buttons">
                    <Button className="intent-save" onClick={()=>addFlow()}> Add flow</Button>
                    <Button className="intent-skip" onClick={()=>skipFlow()}> Skip </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}
export default memo(IntelligenceConfirmationModal);
